<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button parkourBackButton />
    </ion-buttons>

    <ion-title aria-level="1" role="heading">{{ 'team.add-teamlid.title' | translate }}</ion-title>

    <ion-buttons slot="end">
      <parkour-header-action
        [disabled]="busy"
        [label]="'team.add-teamlid.invite' | translate"
        form="teamlid-add"
        icon="paper-plane"
        type="submit"
      />
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  ><!-- TODO: Add error messages and input text to JSON -->
  <parkour-page-layout>
    <parkour-page-image
      classes="absolute top-0 left-0 z-0"
      src="/assets/team/background/background_team_blur.jpg"
    />

    <div class="relative z-10 py-8 container container-space flex flex-col gap-y-8">
      <form (ngSubmit)="onSubmit()" class="container-1-col" id="teamlid-add">
        <div class="bg-n-200 rounded p-4 flex flex-col gap-y-4">
          <h2 class="typo-h3">{{ 'team.add-teamlid.title' | translate }}</h2>

          <div class="flex flex-col gap-y-4">
            <parkour-form-field
              [inputFormControl]="registerTeamlidForm.controls.volledigeNaam"
              [label]="'Volledige naam'"
              [required]="true"
              class="block"
              inputId="volledige-naam"
            >
              <parkour-input
                autocomplete="name"
                [formControl]="registerTeamlidForm.controls.volledigeNaam"
                class="block"
                inputId="volledige-naam"
                type="text"
              />
            </parkour-form-field>

            <parkour-form-field
              [additionalErrors]="getRolErrors()"
              [errorMessages]="{
                rolRequired: 'Kies een rol',
              }"
              [inputFormControl]="registerTeamlidForm.controls.rol"
              [label]="'Rol'"
              [required]="true"
              class="block"
              inputId="rol"
            >
              <parkour-select
                [formControl]="registerTeamlidForm.controls.rol"
                [options]="rolOptions"
                [required]="true"
                placeholder="Kies een rol"
                selectId="rol"
              >
              </parkour-select>
            </parkour-form-field>

            <ion-radio-group [formControl]="registerTeamlidForm.controls.type">
              <div class="flex flex-col gap-y-4">
                <parkour-radio
                  [inputId]="'EMAIL'"
                  [label]="getUitnodigingTypeLabel('EMAIL')"
                  [value]="'EMAIL'"
                >
                  @if (registerTeamlidForm.controls.type.value === 'EMAIL') {
                    <parkour-form-field-without-label
                      [additionalErrors]="getEmailErrors()"
                      [errorMessages]="{
                        emailRequired: 'Vul een e-mailadres in.',
                        pattern:
                          'Vul een geldig e-mailadres in. Een e-mailadres bevat @ en een domein. Voorbeeld: email@domein.com',
                      }"
                      [inputFormControl]="registerTeamlidForm.controls.email"
                      [required]="true"
                      [accessibleLabel]="'E-mail'"
                      class="w-full"
                      errorLabel="e-mailadres"
                      inputId="email"
                    >
                      <parkour-input
                        autocomplete="email"
                        [formControl]="registerTeamlidForm.controls.email"
                        class="w-full"
                        inputId="email"
                        inputPlaceholder="E-mail"
                        pattern=".*@.*"
                        type="email"
                      />
                    </parkour-form-field-without-label>
                  }
                </parkour-radio>

                <parkour-radio
                  [inputId]="'SMS'"
                  [label]="getUitnodigingTypeLabel('SMS')"
                  [value]="'SMS'"
                >
                  @if (registerTeamlidForm.controls.type.value === 'SMS') {
                    <parkour-form-field-without-label
                      [additionalErrors]="getSmsErrors()"
                      [errorMessages]="{
                        mobielNummerRequired: 'Vul een gsm-nummer in.',
                        pattern:
                          'Vul een geldig GSM-nummer in. Voeg de landcode toe en gebruik geen spaties. Voorbeeld: +32482455642',
                      }"
                      [inputFormControl]="registerTeamlidForm.controls.sms"
                      [required]="true"
                      [accessibleLabel]="'Gsm-nummer'"
                      class="w-full"
                      errorLabel="Gsm-nummer"
                      inputId="sms"
                    >
                      <parkour-input
                        [formControl]="registerTeamlidForm.controls.sms"
                        autocomplete="tel"
                        class="w-full"
                        inputId="sms"
                        inputPlaceholder="Gsm-nummer"
                        pattern="^\+\d{8,15}$"
                        type="tel"
                      />
                    </parkour-form-field-without-label>
                  }
                </parkour-radio>

                <parkour-radio
                  [inputId]="'QR'"
                  [label]="getUitnodigingTypeLabel('QR')"
                  [value]="'QR'"
                >
                  @if (registerTeamlidForm.controls.type.value === 'QR') {
                    <parkour-form-field-without-label
                      [additionalErrors]="getProfielIdErrors()"
                      [errorMessages]="{
                        profielIdRequired: 'Scan een qr-code.',
                      }"
                      [inputFormControl]="registerTeamlidForm.controls.profielId"
                      [required]="true"
                      [accessibleLabel]="'team.add-teamlid.qr-code-scannen-button' | translate"
                      class="w-full"
                      errorLabel="qr-code"
                      inputId="profielId"
                    >
                      @if (registerTeamlidForm.controls.profielId.value) {
                        <div
                          class="flex flex-row bg-n-300 w-fit pt-1 pb-1 pl-2 pr-2 items-center rounded mt-2"
                        >
                          <p class="font-medium mr-2">Ingescand</p>
                          <parkour-icon class="flex items-center text-positive" name="check" />
                        </div>
                      }
                      @if (
                        registerTeamlidForm.controls.type.value === 'QR' &&
                        !registerTeamlidForm.controls.profielId.value
                      ) {
                        <parkour-button
                          class="block w-full"
                          iconAfter="qr-code"
                          link="qr-code-scan"
                          [routeInfo]="{ overridePopups: true }"
                          variant="tertiary"
                        >
                          {{ 'team.add-teamlid.qr-code-scannen-button' | translate }}
                        </parkour-button>
                      }
                    </parkour-form-field-without-label>
                  }
                </parkour-radio>
              </div>
            </ion-radio-group>
          </div>
        </div>

        <parkour-button
          [disabled]="busy"
          class="block mt-8 w-full"
          iconAfter="paper-plane"
          type="submit"
        >
          {{ 'team.add-teamlid.invite' | translate }}
        </parkour-button>
      </form>
    </div>
  </parkour-page-layout>
</ion-content>
